/*
  Application routes for Material Dashboard 2 React.
  Edit this file to add, remove, or customize routes in the Sidenav and main router.
*/
// Material Dashboard 2 React layouts
import Clients from "layouts/clients";
import { Users } from "pages/Users";
import ContractTemplates from "layouts/admin/contract-templates";
import SignIn from "layouts/authentication/sign-in";
import LoginRequest from "layouts/authentication/login-request";

// @mui icons
import Icon from "@mui/material/Icon";

// Route constants
const ROUTES = {
  SIGN_IN: "/authentication/sign-in",
  LOGIN_REQUEST: "/authentication/login-request",
  CLIENTS: "/clients",
  USERS: "/users",
  CONTRACT_TEMPLATES: "/contract-templates",
};

// Route definitions for the app
const routes = [
  // Auth routes
  {
    type: "route",
    name: "Sign In",
    key: "sign-in",
    route: ROUTES.SIGN_IN,
    component: <SignIn />,
  },
  {
    type: "route",
    name: "Request Access",
    key: "login-request",
    route: ROUTES.LOGIN_REQUEST,
    component: <LoginRequest />,
  },
  // Main app routes
  {
    type: "collapse",
    name: "Clients",
    key: "clients",
    route: ROUTES.CLIENTS,
    icon: <Icon fontSize="small">people</Icon>,
    component: <Clients />,
  },
  {
    type: "collapse",
    name: "Users",
    key: "users",
    icon: <Icon fontSize="small">group</Icon>,
    route: ROUTES.USERS,
    component: <Users />,
  },
  {
    type: "collapse",
    name: "Contract Templates",
    key: "contract-templates",
    icon: <Icon fontSize="small">description</Icon>,
    route: ROUTES.CONTRACT_TEMPLATES,
    component: <ContractTemplates />,
    beta: true,
  }
];

export default routes;
